import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const SubscriptionSettings = () => {
  const [userData, setUserData] = useState({ email: '', user_name: '', role: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('free');
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const user = response.data.data.user;
        setUserData(user);
        const initialType = user.subs_type === 'paid' ? 'paid' : 'free';
        setSubscriptionType(initialType);

        if (user.subs_type === 'paid') {
          fetchSubscriptionDetails(token);
        }
      } catch (error) {
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const fetchSubscriptionDetails = async (token) => {
    try {
      const response = await axios.get(`${config.baseURL}/subscription-data-lists`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const { active_subscriptions, user_subscriptions } = response.data;
      setActiveSubscriptions(active_subscriptions);
      setUserSubscriptions(user_subscriptions.map(sub => ({
        ...sub,
        isChecked: sub.status === 'active' && active_subscriptions.some(activeSub => activeSub.id === sub.subscription_plan_id),
      })));
      
    } catch (error) {
      console.error('Error fetching subscription details', error);
    }
  };

  const handleSubscriptionChange = (e) => {
    const newType = e.target.value;
    setSubscriptionType(newType);

    if (newType === 'paid') {
      const token = localStorage.getItem('token');
      fetchSubscriptionDetails(token);
    } else {
      setActiveSubscriptions([]);
      setUserSubscriptions([]);
    }
  };

  const handleCheckboxChange = (subscriptionId) => {
    setUserSubscriptions(prevUserSubscriptions => {
      const existingSubscription = prevUserSubscriptions.find(sub => sub.subscription_plan_id === subscriptionId);

      if (existingSubscription) {
        return prevUserSubscriptions.map(subscription =>
          subscription.subscription_plan_id === subscriptionId
            ? { ...subscription, isChecked: !subscription.isChecked }
            : subscription
        );
      } else {
        return [
          ...prevUserSubscriptions,
          {
            subscription_plan_id: subscriptionId,
            isChecked: true,
            plan_amount: ''
          }
        ];
      }
    });
  };

  const handleAmountChange = (subscriptionId, amount) => {
    setUserSubscriptions(prevUserSubscriptions =>
      prevUserSubscriptions.map(subscription =>
        subscription.subscription_plan_id === subscriptionId
          ? { ...subscription, plan_amount: amount }
          : subscription
      )
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Check if subscription type is 'paid' and if no plans are selected
    if (subscriptionType === 'paid' && !userSubscriptions.some(sub => sub.isChecked)) {
      setErrorMessage('Please select at least one subscription plan.');
      setSuccessMessage('');
      return; // Stop the save process
    }

    try {
      const token = localStorage.getItem('token');

      const payload = {
        subs_type: subscriptionType,
        subscriptions: userSubscriptions.map(sub => ({
          subscription_plan_id: sub.subscription_plan_id,
          plan_amount: sub.plan_amount || 0, // Ensure amount is always sent, even if empty
          status: sub.isChecked ? 'active' : 'inactive', // Set status based on checkbox
        })),
      };

      await axios.post(
        `${config.baseURL}/update-subs-type`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSuccessMessage('Subscription type updated successfully');
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Error updating subscription type');
      setSuccessMessage('');
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div>
      <div className="main_patreonpass_wrapper">
        <div className="patreonpass_container">
          <div className="left_sidebar">
            <MainSidebar />
          </div>
          <div className="patreonpass_main_content edit_profile_settings" id="content">
            <div className="left_main_content">
              <div className="feed_wrapper">
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <button className="profile_back_btn" onClick={handleBackClick}>
                      <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                    <h1>SETTINGS</h1>
                  </div>
                </div>
                <div className="menus_all_wrapper">
                  <div className="edit_settings_menu_list">
                    <h3><a href={`/${userData.user_name}`}>@{userData.user_name}</a></h3>
                    <ul>
                      <li><Link className="active_profile_menu" to="/EditProfile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/AccountSettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/PrivacySafetySettings">Privacy and safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                      <li><Link to="/NotificationSettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_main_content">
              <form onSubmit={handleSave}>
                <div className="page_title_with_dropdown notification_page">
                  <div className="page_heading">
                    <h1>Subscription</h1>
                  </div>
                </div>
                <div className={`fields_menu_bottom_box_edit_account edit_username_fields ${userData.role === 'user' ? 'disable_section' : ''}`}>
                  <div className="editable_fields_user social_account_update">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-2 position_relative">
                          <select className="form-control" value={subscriptionType} onChange={handleSubscriptionChange}>
                            <option value="free">$ Free</option>
                            <option value="paid">Paid</option>
                          </select>
                          <label htmlFor="subsc" className="placeholder-label">Select Subscription Type</label>
                        </div>
                        {subscriptionType === 'paid' && (
                          <div className="mb-2 position_relative paid_subscrition_options">
                            <table className="subscription_details_updation table">
                              <thead> 
                                <tr>
                                  <th>Action</th>
                                  <th>Duration</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                              {activeSubscriptions.map(subscription => {
                                const userSubscription = userSubscriptions.find(userSub => userSub.subscription_plan_id === subscription.id) || {};

                                return (
                                  <tr key={subscription.id}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={userSubscription.isChecked || false}
                                        onChange={() => handleCheckboxChange(subscription.id)}
                                      />
                                    </td>
                                    <td>{subscription.days} days</td>
                                    <td>
                                    
  <input
    className="form-control"
    placeholder="Enter Amount"
    type="number"
    value={userSubscription.plan_amount || ''}
    min="1" // Ensure the value cannot go below 1
    max="10000" // Set the max limit to 10000
    onInput={(e) => {
      const newValue = e.target.value;
      // Prevent non-numeric input and ensure the value is within the valid range
      if (newValue === '' || (parseFloat(newValue) >= 1 && parseFloat(newValue) <= 10000)) {
        handleAmountChange(subscription.id, newValue);
      }
    }}
  />



                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 text-right">
                        <button type="submit" className="create_post_btn_area post_btn">Save</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="message_status">
                  {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                  {successMessage && <div className="alert alert-success">{successMessage}</div>}
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSettings;
